import { Shield, UserCheck, Users } from "lucide-react";
import { memo } from "react";

import { UserStatus } from "../model/constants";

import { Card, CardContent } from "@/common/components";

interface UserStatisticsProps {
  totalUsers: number;
  blockedUsers: number;
  adminUsers: number;
  status: UserStatus;
  onStatusChange: (status: UserStatus) => void;
  onRoleFilterChange?: (role: string) => void;
  onResetFilters?: () => void;
}

export const UserStatistics = memo(function UserStatistics({
  totalUsers,
  blockedUsers,
  adminUsers,
  status,
  onStatusChange,
  onRoleFilterChange,
  onResetFilters,
}: UserStatisticsProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
      <button
        onClick={() => {
          onResetFilters?.();
        }}
        key={"all"}
        aria-pressed={status === UserStatus.All}
      >
        <Card
          className={`cursor-pointer transition-shadow h-28 md:h-32 md:p-3 p-4 overflow-hidden ${
            status === UserStatus.All
              ? "shadow-md ring-1 ring-zinc-200 border-gray-400"
              : "hover:shadow-md"
          }`}
        >
          <CardContent className="">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-muted-foreground">Всего пользователей</p>
                <p className="text-2xl font-bold mt-5 md:text-center text-left">{totalUsers}</p>
              </div>
              <Users className="h-8 w-8 text-primary" />
            </div>
          </CardContent>
        </Card>
      </button>

      <button
        onClick={() => {
          onStatusChange(UserStatus.Blocked);
        }}
        key={"blocked"}
        aria-pressed={status === UserStatus.Blocked}
      >
        <Card
          className={`cursor-pointer transition-shadow h-28 md:h-32 md:p-3 p-4 overflow-hidden ${
            status === UserStatus.Blocked
              ? "shadow-md ring-1 ring-zinc-200 border-gray-400"
              : "hover:shadow-md"
          }`}
        >
          <CardContent className="">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-muted-foreground">Заблокированных</p>
                <p className="text-2xl font-bold text-green-600 mt-5 md:text-center text-left">
                  {blockedUsers}
                </p>
              </div>
              <UserCheck className="h-8 w-8 text-green-600" />
            </div>
          </CardContent>
        </Card>
      </button>

      <button
        onClick={() => {
          onStatusChange(UserStatus.Admin);
          onRoleFilterChange?.(UserStatus.Admin);
        }}
        key={"moder"}
        aria-pressed={status === UserStatus.Admin}
      >
        <Card
          className={`cursor-pointer transition-shadow h-28 md:h-32 md:p-3 p-4 overflow-hidden ${
            status === UserStatus.Admin
              ? "shadow-md ring-1 ring-zinc-200 border-gray-400"
              : "hover:shadow-md"
          }`}
        >
          <CardContent className="">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-muted-foreground">Модераторов</p>
                <p className="text-2xl font-bold text-blue-600 mt-5 md:text-center text-left">
                  {adminUsers}
                </p>
              </div>
              <Shield className="h-8 w-8 text-blue-600" />
            </div>
          </CardContent>
        </Card>
      </button>
    </div>
  );
});
